const INK = "#2E2A8F";

export const Logo = ({ stacked = false, center = false, className = "" }) => {
  const align = center ? "text-center" : "";
  if (stacked) {
    return (
      <div className={`${align} ${className}`} data-testid="logo">
        <div className="font-serif-brand font-extrabold tracking-tight leading-[0.92]" style={{ color: INK }}>
          <span className="block text-5xl sm:text-6xl">Agenda</span>
          <span className="block text-5xl sm:text-6xl">Terapias</span>
        </div>
        <p className="font-serif-brand italic text-xl sm:text-2xl text-slate-900 mt-4">
          “Gana claridad, orden y clientes”
        </p>
      </div>
    );
  }
  return (
    <div className={`${align} ${className}`} data-testid="logo">
      <span className="font-serif-brand font-extrabold text-xl tracking-tight leading-none" style={{ color: INK }}>
        Agenda Terapias
      </span>
      <p className="font-serif-brand italic text-xs text-slate-500 mt-1">
        Gana claridad, orden y clientes
      </p>
    </div>
  );
};
